// extracted by mini-css-extract-plugin
module.exports = {"fileService":"\"http://at.otwb.linshimuye.com\""};